import { render, staticRenderFns } from "./SkeletonCardList.vue?vue&type=template&id=a6b57686&"
import script from "./SkeletonCardList.vue?vue&type=script&lang=js&"
export * from "./SkeletonCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports